import { inject, Injectable, linkedSignal, Query, signal, Signal } from '@angular/core';
import { Dictionary, ReadonlyRepositoryListService, Result } from '@softline/core';
import { RohstoffbilanzResult } from '../data/result';
import { RohstoffbilanzRepository } from '../repositories/rohstoffbilanz.repository';

@Injectable()
export class RohstoffbilanzService extends ReadonlyRepositoryListService<
  RohstoffbilanzResult,
  Result<RohstoffbilanzResult[]>,
  Dictionary<unknown> | undefined
> {
  readonly #params = signal<Signal<Dictionary<unknown> | undefined>>(signal(undefined));

  override params: Signal<Dictionary<unknown> | undefined> = linkedSignal(() =>
    this.#params()()
  );

  constructor() {
    super(inject(RohstoffbilanzRepository));
  }

  protected override getItems(
    result: Result<RohstoffbilanzResult[]> | null | undefined
  ): RohstoffbilanzResult[] {
    return result?.result ?? [];
  }

  register(params: Signal<Dictionary<unknown> | undefined>) {
    this.#params.set(params);
  }
}
